import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const paginate = <T>(array: Array<T> | undefined, page_size: number, page_number: number) => {
  return array?.slice((page_number - 1) * page_size, page_number * page_size) || [];
};
export const calcTotalPage = (filteredDataLength: number, pageSize: number) => {
  return filteredDataLength > 0 ? Math.ceil(filteredDataLength / pageSize) : 1;
};

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy: ', err);
  }

  let isCopySuccess = false;

  const textArea = document.createElement('textarea');
  textArea.style.position = 'fixed';
  textArea.style.left = '-9999px';
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    isCopySuccess = true;
  } catch (err) {
    console.error('Failed to copy: ', err);
    isCopySuccess = false;
  } finally {
    document.body.removeChild(textArea);
  }
  return isCopySuccess;
};

// Re-export the server version hook
export { useServerVersion } from './useServerVersion';

// Re-export the auth status hook
export { useAuthStatus } from './useAuthStatus';
